import { useTranslation } from 'react-i18next'

import { SETTINGS_MENU_PROCESS_STRUCTURE_ITEM } from '../../../../../constants/menu.settings'
import { getQaSelector } from '../../../../../utils/common'
import { getWebappLinkPrefix } from '../../../../../utils/route'
import { Link } from '../../../../Link'
import Text from '../../../../Text'
import {
  QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_EMPTY,
  QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_SETTINGS_LINK,
} from '../../../CalendarSettings.constants'

import * as styles from './TaskTypesFieldEmpty.module.css'

function TaskTypesFieldEmpty() {
  const { t } = useTranslation()

  return (
    <div
      {...getQaSelector({ value: QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_EMPTY })}
      className={styles.TaskTypesFieldEmpty}
    >
      <Text isSecondary>{t('CalendarSettings.NoTaskTypesKey')}</Text>
      <Link
        {...getQaSelector({
          value: QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_SETTINGS_LINK,
        })}
        reloadDocument
        to={getWebappLinkPrefix(SETTINGS_MENU_PROCESS_STRUCTURE_ITEM.to)}
      >
        {t('CalendarSettings.TaskTypesSettingsLinkKey')}
      </Link>
    </div>
  )
}

export default TaskTypesFieldEmpty
